<template>
  <b-container fluid class="d-flex flex-column h-100">
    <b-row>
      <b-col class="p-0">
        <Cabecalho />
      </b-col>
    </b-row>
    <b-row class="flex-grow-1">
      <b-col class="p-0 d-flex">
        <!-- </b-col> -->
        <!-- <b-col class="p-0"> -->
        <router-view class="w-100"></router-view>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import Cabecalho from "@/components/template/Cabecalho.vue";
//import barramento from "@/barramento";
export default {
  name: "app",
  components: {
    Cabecalho,
  },
  data() {
    return {
      validatingToken: true,
    };
  },
  methods: {
    async validateToken() {
      this.validatingToken = true;

      const json = localStorage.getItem(
        "__" + process.env.VUE_APP_CI_PROJECT_NAME + "_app"
      );
      const userData = JSON.parse(json);
      this.$store.commit("setLoggedUser", null);

      if (!userData) {
        this.validatingToken = false;
        localStorage.removeItem("__" + process.env.CI_PROJECT_NAME + "_app");
        this.$router.push("/login");
        return;
      }
      this.$http.defaults.headers.common["Authorization"] =
        "bearer " + userData.token;
      const res = await this.$http.post("/validateToken", userData);

      if (res.data.success) {
        this.$session.start();
        this.$session.set("jwt", userData.token);
        this.$store.commit("setLoggedUser", userData.userdata);
        this.$store.commit("setPermissions", userData.permissoes);
        this.$router.push("/inicio");
      } else {
        localStorage.removeItem("__" + process.env.CI_PROJECT_NAME + "_app");
        this.$router.push("/login");
      }

      this.validatingToken = false;
    },
    renewToken() {
      setInterval(() => {
        const json = localStorage.getItem(
          "__" + process.env.VUE_APP_CI_PROJECT_NAME + "_app"
        );
        var userData = JSON.parse(json);
        // só vai renovar o token se houver os dados no localStorage
        // e logo em seguida vai atualizar o token no header de Authorization e no localStorage
        if (userData) {
          this.$http.post("/renewToken").then((response) => {
            this.$http.defaults.headers.common["Authorization"] =
              "bearer " + response.data.token;
            userData.token = response.data.token;
            localStorage.setItem(
              "__" + process.env.VUE_APP_CI_PROJECT_NAME + "_app",
              JSON.stringify(userData)
            );
          });
        }
      }, 1000 * 60 * 10);
    },
  },
  created() {
    this.validateToken();
    this.renewToken();
  },
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  font-size: 1em;
}
body {
  display: flex;
  flex-direction: column;
}
.flex-grow-1 {
  flex-grow: 1;
}
.v-sidebar-menu {
  left: 0px !important;
}
</style>
